import React from 'react'
import { WidgetGuard } from 'features/types'
import { TopicInaccessibleGuard, UnexpectedServiceErrorGuard } from '../../../share/guards'
import StreamWidgetTopicIndexNotReadyGuard from './StreamWidgetTopicIndexNotReadyGuard'
import StreamWidgetEmptyResultGuard from './StreamWidgetEmptyResultGuard'

const StreamWidgetDataGuards: WidgetGuard = ({ widgetId, children }) => (
  <TopicInaccessibleGuard widgetId={widgetId}>
    <UnexpectedServiceErrorGuard widgetId={widgetId}>
      <StreamWidgetTopicIndexNotReadyGuard widgetId={widgetId}>
        <StreamWidgetEmptyResultGuard widgetId={widgetId}>{children}</StreamWidgetEmptyResultGuard>
      </StreamWidgetTopicIndexNotReadyGuard>
    </UnexpectedServiceErrorGuard>
  </TopicInaccessibleGuard>
)

export default StreamWidgetDataGuards
